import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { referFriendEmailValidationError } from '../../utils/berkeleyEmailAccess';
import './UserMenuCollagesSection.css';

/**
 * Friend email entry for inviting someone to share daily vibe checks.
 */
export default function DailyVibeEmailInviteModal({ open, onClose, onSendInvite }) {
  const [friendEmailInput, setFriendEmailInput] = useState('');
  const [friendEmailError, setFriendEmailError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setFriendEmailInput('');
    setFriendEmailError('');
    setSubmitting(false);
  }, [open]);

  const closeModal = () => {
    if (submitting) return;
    onClose?.();
  };

  if (!open || typeof onSendInvite !== 'function') return null;

  return createPortal(
    <div
      className="user-menu-match-removal-confirm-overlay"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="user-menu-match-removal-confirm cart-popup vibe-popup user-menu-coupon-redeem-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="user-menu-daily-vibe-invite-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="cart-popup-close"
          aria-label="Close"
          onClick={closeModal}
        >
          ×
        </button>
        <h3
          id="user-menu-daily-vibe-invite-title"
          className="match-explainer-title user-menu-match-removal-confirm-title"
        >
          Invite by email
        </h3>
        <p className="user-menu-coupon-redeem-hint">
          We&apos;ll email your friend a link to sign up and share daily vibe checks with you.
        </p>
        <form
          className="user-menu-coupon-redeem-form"
          onSubmit={async (e) => {
            e.preventDefault();
            if (submitting) return;
            const err = referFriendEmailValidationError(friendEmailInput);
            if (err) {
              setFriendEmailError(err);
              return;
            }
            setSubmitting(true);
            setFriendEmailError('');
            try {
              const result = await onSendInvite(String(friendEmailInput).trim());
              if (result?.ok) {
                onClose?.();
              } else {
                setFriendEmailError(result?.error || 'Could not send that invite.');
              }
            } catch {
              setFriendEmailError('Something went wrong. Try again.');
            } finally {
              setSubmitting(false);
            }
          }}
        >
          <input
            type="email"
            className="user-menu-coupon-redeem-input user-menu-friend-email-input"
            value={friendEmailInput}
            onChange={(e) => {
              setFriendEmailInput(e.target.value);
              if (friendEmailError) setFriendEmailError('');
            }}
            placeholder="friend@example.com"
            autoComplete="email"
            inputMode="email"
            aria-invalid={!!friendEmailError}
            aria-describedby={friendEmailError ? 'user-menu-daily-vibe-invite-err' : undefined}
            disabled={submitting}
          />
          {friendEmailError ? (
            <p id="user-menu-daily-vibe-invite-err" className="user-menu-coupon-redeem-error" role="alert">
              {friendEmailError}
            </p>
          ) : null}
          <div className="user-menu-match-removal-confirm-actions user-menu-coupon-redeem-actions">
            <button
              type="button"
              className="vibe-popup-btn match-flow-close-btn"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button type="submit" className="vibe-popup-btn" disabled={submitting}>
              {submitting ? 'Sending…' : 'Send invite'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body,
  );
}
